import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';

/** @class CloseButtonMixin */
/** @method */
export var CloseButtonMixin = function CloseButtonMixin(props) {
  return token({
    buttonSize: 'CloseButton.buttonSize',
    iconColor: 'CloseButton.iconColor',
    backgroundColor: 'CloseButton.backgroundColor',
    boxShadow: 'CloseButton.boxShadowFocus',
    borderRadius: 'CloseButton.borderRadius',
    padding: 'CloseButton.padding',
    margin: 'CloseButton.margin'
  }, function (_ref) {
    var buttonSize = _ref.buttonSize,
      iconColor = _ref.iconColor,
      backgroundColor = _ref.backgroundColor,
      boxShadow = _ref.boxShadow,
      borderRadius = _ref.borderRadius,
      padding = _ref.padding,
      margin = _ref.margin;
    return css(["cursor:pointer;border:0;background:none;padding:", ";margin:", ";box-sizing:content-box;color:", ";border-radius:", ";width:", "px;height:", "px;display:inline-flex;justify-content:center;align-items:center;&:hover,&:focus{background:", ";}outline:none;&:focus{box-shadow:", ";}"], padding ? padding + "px" : spaceMixin('xs')(props), margin ? margin + "px" : "-" + spaceMixin('xs')(props), iconColor, borderRadius, buttonSize, buttonSize, backgroundColor, boxShadow);
  })(props);
};